import React, { Component } from 'react';

import { Box } from '@mui/material';

import BookingCancelledToggle from './BookingCancelledToggle';
import SurchargeToggle from './SurchargeToggle';
import TourCancellationWarning from './TourCancellationWarning';

export default class FullRefundVariant extends Component {
  render() {
    const shouldDisallowTourCancellation =
      this.props.refund.is_tour && this.props.refund.is_tour_with_active_optional_extras;

    return (
      <Box id="FullRefundVariant">
        {this.props.with_fee && (
          <Box id="fee">
            <label>Fee Charged to Customer:</label>
            <input
              name="fee"
              value={this.props.tmpValue('fee')}
              onChange={this.props.handleTmpChange}
              className="data-hj-whitelist"
              data-cy="Fee Charged to Customer"
            />
          </Box>
        )}
        {this.props.refund.has_surcharge && (
          <SurchargeToggle
            handleFlagChange={this.props.handleFlagChange}
            surchargeInfo={this.props.surchargeInfo}
            is_refunded_surcharge={this.props.refund.is_refunded_surcharge}
          />
        )}
        <TourCancellationWarning shouldDisallowTourCancellation={shouldDisallowTourCancellation} />
        {!shouldDisallowTourCancellation && !this.props.refund.is_subscription && (
          <BookingCancelledToggle
            handleFlagChange={this.props.handleFlagChange}
            mark_cancelled={this.props.refund.mark_cancelled}
          />
        )}
      </Box>
    );
  }
}
